import { render, staticRenderFns } from "./SplitPanel.vue?vue&type=template&id=c3747aac&scoped=true"
import script from "./SplitPanel.vue?vue&type=script&lang=js"
export * from "./SplitPanel.vue?vue&type=script&lang=js"
import style0 from "./SplitPanel.vue?vue&type=style&index=0&id=c3747aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3747aac",
  null
  
)

export default component.exports